import { handleActions } from 'redux-actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import * as $app from 'modules/app';
import * as actions from './actions';

const InitialState = {
  profile: null,
  tempCoverPhotoUrl: null,
  tempProfilePhotoUrl: null,
};

const reducerBase = handleActions(
  {
    [actions.fetchUserProfileSuccess]: (state, { payload: profile }) => ({
      ...state,
      profile,
    }),

    [actions.updateUserProfileSuccess]: (state, { payload: profile }) => ({
      ...state,
      profile,
    }),

    [actions.uploadCoverPhotoSuccess]: (state, { payload: url }) => ({
      ...state,
      tempCoverPhotoUrl: url,
    }),

    [actions.uploadProfilePhotoSuccess]: (state, { payload: url }) => ({
      ...state,
      tempProfilePhotoUrl: url,
    }),
  },
  InitialState
);

const reducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return reducerBase(state, action);
};

const persistConfig = {
  key: 'userProfile',
  storage: storage,
  whitelist: ['profile'],
};

export const userProfileReducer = persistReducer(persistConfig, reducer);
